import { postalCodeRegex } from "../regex/postalCode";

export const isValidForRegex = (value: string, regex: RegExp) => {
  return regex.test(value);
};

export const isPostalCodeValid = (postalCode: string) => {
  return isValidForRegex(postalCode, postalCodeRegex);
};
